module.exports = __webpack_public_path__ + "static/media/flag-kri.7156aaa0.webp";